import { Component, OnInit } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AdminService } from '@app/main/admin/admin.service';
import { DialogService, ReportService, SnackService } from '@shared/services';
import { IReport, ReportStatus } from '@shared/interfaces';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-report-edit',
    templateUrl: './admin-report-edit.component.html',
    styleUrls: ['./admin-report-edit.component.scss'],
    standalone: false
})
export class AdminReportEditComponent extends AdminActionsDirective implements OnInit {
    formGroup: UntypedFormGroup;

    constructor(
        private reportService: ReportService,
        private fb: UntypedFormBuilder,
        private snack: SnackService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    ngOnInit() {
        if (this.item.reportStatus === ReportStatus.released) {
            this.goToReports();
        } else {
            this.buildForm();
        }
    }

    async updateItem(event): Promise<void> {
        this.disableSubmitter(event);

        if (this.formGroup.valid) {
            try {
                const formValue = this.formGroup.getRawValue();
                const payload = {
                    id: formValue.id,
                    template: formValue.template,
                    dueDate: formValue.dueDate,
                    reportStartDate: formValue.reportStartDate,
                    reportEndDate: formValue.reportEndDate
                };
                const result = await this.reportService.updateItemMeta(payload);
                this.snack.openSnackBarSuccess(`Report item ${result.id} updated successfully.`);
                this.goToReports();
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }

        this.enableSubmitter(event);
    }

    private buildForm(): void {
        const currentYear = new Date().getFullYear();

        this.formGroup = this.fb.group({
            id: new FormControl({ value: this.item.id, disabled: true }),
            responsible: new FormControl({ value: this.item.responsible, disabled: true }),
            template: new FormControl({ value: this.item.template, disabled: true }, Validators.required),
            dueDate: new FormControl(new Date(this.item.dueDate), Validators.required),
            reportStartDate: new FormControl(
                this.item.reportStartDate || new Date(currentYear - 1, 9, 1),
                Validators.required
            ),
            reportEndDate: new FormControl(this.item.reportEndDate || new Date(currentYear, 9, 31), Validators.required)
        });
    }

    get item(): IReport {
        return this.selectedItem;
    }
}
